import React from 'react'

export const NotFound = () => {
    return (
        <div>
            404 Error Not Found            
        </div>
    )
}

export default NotFound; 
